/**
 * @fileoverview Hero Classes and tiers.
 */

export const basicClasses = [
    'Warrior',
    'Knight',
    'Thief',
    'Archer',
    'Priest',
    'Wizard',
    'Monk',
    'Pirate',
    'Seer',
    'Berserker',
    'Legionnaire',
    'Scholar',
]

export const advancedClasses = ['Paladin', 'DarkKnight', 'Summoner', 'Ninja', 'Shapeshifter', 'Bard']

export const eliteClasses = ['Dragoon', 'Sage', 'SpellBow']

export const exaltedClasses = ['DreadKnight']

export const PROFESSIONS_AR = ['Mining', 'Gardening', 'Foraging', 'Fishing']
